import { TOGGLE_TO_IMAGE, TOGGLE_TO_VIDEO } from '.'

const toggleImageAction = () => {
  return {
    type: TOGGLE_TO_IMAGE
  }
}
const toggleVideoAction = () => {
  return {
    type: TOGGLE_TO_VIDEO
  }
}

export { toggleImageAction, toggleVideoAction }
